// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"724fe8d6","453":"6d9d6289","455":"a2ce25e8","977":"72c3030f"}[chunkId] + ".chunk.js";
};